import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import Budget from "models/Budget";
import StayType from "models/StayType";
import Transport from "models/Transport";
import Duration from "models/Duration";
import Country from "models/Country";
import User from "models/User";

export interface GlobalSlice {
  dataLoaded: boolean;
  budgets: Budget[];
  transports: Transport[];
  stayTypes: StayType[];
  durations: Duration[];
  countries: Country[];
  loading: boolean;
  isAuthenticated: boolean;
  token: string;
  user?: User;
}

const initialState: GlobalSlice = {
  dataLoaded: false,
  budgets: [],
  transports: [],
  stayTypes: [],
  durations: [],
  countries: [],
  loading: false,
  isAuthenticated: null,
  token: null,
  user: null
};

const globalReducer = createSlice({
  name: "global",
  initialState,
  reducers: {
    SET_TOKEN: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    SET_USER: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    IS_AUTHENTICATED: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    LOAD_DATA: (state) => {
      state.loading = true;
    },
    LOAD_DATA_SUCCESS: (state, action) => {
      state.loading = false;
      state.dataLoaded = true;
      state.budgets = action.payload.budgets;
      state.transports = action.payload.transports;
      state.stayTypes = action.payload.stayTypes;
      state.durations = action.payload.durations;
      state.countries = action.payload.countries;
    }
  },
});

export const {
  LOAD_DATA,
  LOAD_DATA_SUCCESS,
  IS_AUTHENTICATED,
  SET_TOKEN,
  SET_USER
} = globalReducer.actions;

export default globalReducer.reducer;
